const logs = {
    page_title: 'Denetim Kayıtları',
    title: 'Denetim Kayıtları',
    subtitle: 'Yöneticiniz ve kullanıcılarınız tarafından yapılan kimlik doğrulama olaylarının kayıt verilerini görüntüleyin',
    event: 'Durum',
    user: 'Kullanıcı',
    application: 'Uygulama',
    time: 'Süre',
    filter_by: 'Göre filtrele',
    last_1_hour: 'Son 1 saat',
    last_24_hours: 'Son 24 saat',
    last_7_days: 'Son 7 gün',
    last_30_days: 'Son 30 gün',
    custom_range: 'Özel aralık',
    from: 'Başlangıç',
    to: 'Bitiş',
};
export default Object.freeze(logs);
